export default "__VITE_ASSET__39fc693f__"